import request, { METHODS } from "src/utils/api-base";

const publicPurchaseInvoiceApis = {
  getPublicPurchaseInvoice: (id: string) => {
    return request({
      route: `/app/public-purchase-invoice/${id}`,
      method: METHODS.GET,
      auth: false,
    });
  },
};

export default publicPurchaseInvoiceApis;
